;(function(window, $) {

    window.ns = window.ns || {};

    window.$cache['body'] = window.$cache['body'] || $('body');

    window.ns['object'] = {
        init: function() {
            registerEvents();
            //initFancybox();

            $('.js-my-selection-trigger').mySelection();
            $('.js-credit-calc-modal').creditModal({});

            // Card price switcher
            // Default Options {saleLabel: 'Продажа', rentLabel: 'Аренда'}
            $('.js-price-selector').objectPriceSwitcher({});

            // Credit calculator
            $('.js-credit-calc').creditCalc({});

            // google map
            window.googleMapOnAPILoad = function() {

                $('#object-map').googleMap();
            };

            loadGoogleMap('googleMapOnAPILoad');
        }
    };

    function registerEvents() {
        // show|hide more images on card page
        $('.js-card_show-more-imgs').click(function(e){
            e.preventDefault();
            var imgsWrap = $('.additional-imgs'),
                className = 'show-all',
                textWrap = $(this).find('span');

            imgsWrap.toggleClass(className);
            imgsWrap.hasClass(className) ?
                textWrap.text($(this).data('hide-text')) :
                textWrap.text($(this).data('show-text'));
        });
    }

    /*
    function initFancybox() {
        $(".additional-imgs a, .main-image").fancybox({
            prevEffect	: 'none',
            nextEffect	: 'none',
            type: 'image',
            padding: [0, 10, 0, 10],
            afterClose : function(){
                if (window.$cache['body'].hasClass('is-overflowHidden')){
                    window.$cache['body'].removeClass('is-overflowHidden')
                }
            },
            afterShow:function(){
                var $_fw = document.querySelector('.fancybox-wrap');
                var fwc = new Hammer($_fw);
                window.$cache['body'].addClass('is-overflowHidden')
                fwc.on('swipe', function(e){
                    if (e.direction === 4) {
                        $.fancybox.prev( );
                    } else {
                        $.fancybox.next( );
                    }
                })
            },
            helpers	: {
                overlay: {
                    locked: false
                },
                thumbs	: {
                    width	: 110,
                    height	: 70
                }
            }
        });
    }
    */

    function loadGoogleMap(callbackName) {
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + Resources['googleMapApiKey'] + '&callback=' + callbackName;
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }

    $('.type-switcher-icon').on('click', function () {
        var showSwitcherText = 'sale-type-switcher--show';
        var switcherDiv = $('.sale-type-switcher');

        var textSale = $(switcherDiv).data('sale');
        var textRent = $(switcherDiv).data('rent');

        $('.sale-type-switcher').toggleClass('sale-type-switcher--show');

        if ($('.sale-type-switcher.sale-type-switcher--show').length > 0) {
            $('.sale-type-switcher').text(textRent);
            $('.sale-price-switcher').hide();
            $('.rent-price-switcher').show();
        } else {
            $('.sale-type-switcher').text(textSale);
            $('.sale-price-switcher').show();
            $('.rent-price-switcher').hide();
        }
    });
})(window, jQuery);